import {
  CalculatorBodyText,
  CalculatorHeadline,
  CalculatorListItem,
  CalculatorTopicH2Headline,
  PreCalculatorHeadline,
} from "src/components/Calculator/CalculatorTypography";
import { MenuItem, makeStyles } from "@material-ui/core";
import React, { FC, useState } from "react";

import { CalculatorButton } from "src/components/Calculator/components/CalculatorButton";
import { CalculatorButtonLinkCentered } from "src/components/Calculator/components/CalculatorButtonLinkCentered";
import { CalculatorImage } from "src/components/Calculator/CalculatorImage";
import CalculatorInputSection from "src/components/Calculator/CalculatorInputSection";
import { CalculatorLayout } from "src/components/Calculator/CalculatorLayout";
import CalculatorMultipleSelect from "src/components/Calculator/CalculatorMultipleSelect";
import { CalculatorResultsTitle } from "src/components/Calculator/components/CalculatorResultsTitle";
import CycleverseDivider from "src/components/CycleverseDivider";
import { DisplayResult } from "src/components/Calculator/components/DisplayResult";
import LocaleLink from "src/components/Navigation/LocaleLink";
import SeoHead from "src/components/Seo/SeoHead";
import { TheCycleverseTheme } from "src/theme";
import { spokeLength } from "src/components/Calculator/BikeSpokeFolmulas";
import useTranslation from "next-translate/useTranslation";

const localNumber = (values, floatSize = 2, lang = "de-DE") => Number(values?.toFixed(floatSize))?.toLocaleString(lang);

const BIKE_TYPE = ["Vorderrad", "Vorderrad mit Scheibenbremse", "Hinterrad", "Hinterrad mit Scheibenbremse"];

const field3Images = {
  [BIKE_TYPE[0]]: "/images/calculators/Speichenrechner-Vorderrad.svg",
  [BIKE_TYPE[1]]: "/images/calculators/Speichenrechner-Vorderrad-Scheibenbremse.svg",
  [BIKE_TYPE[2]]: "/images/calculators/Speichenrechner-Hinterrad.svg",
  [BIKE_TYPE[3]]: "/images/calculators/Speichenrechner-Hinterrad-Scheibenbremse.svg",
};

const field4Images = {
  [BIKE_TYPE[0]]: "/images/calculators/Speichenrechner-Lochkreisdurchmesser-Vorderrad.svg",
  [BIKE_TYPE[1]]: "/images/calculators/Speichenrechner-Lochkreisdurchmesser-Vorderrad-Scheibenbremse.svg",
  [BIKE_TYPE[2]]: "/images/calculators/Speichenrechner-Lochkreisdurchmesser-Hinterrad.svg",
  [BIKE_TYPE[3]]: "/images/calculators/Speichenrechner-Lochkreisdurchmesser-Hinterrad-Scheibenbremse.svg",
};

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  headerContainer: {
    textAlign: "center",
  },
  link: {
    textDecoration: "none",
  },
  button: {
    backgroundColor: theme.buttonBackgroundColor,
    color: theme.buttonColor,
    "&:hover": {
      backgroundColor: theme.buttonBackgroundColor,
    },
  },
  bottomTitle: {
    fontFamily: "Roboto 300",
    fontSize: "16px",
    lineHeight: "23px",
    fontWeight: 900,
  },
  calculateButton: {
    backgroundColor: theme.buttonBackgroundColor,
    color: theme.buttonColor,
  },
  amount: {
    fontFamily: "Roboto 300",
    fontSize: "24px",
    fontWeight: "bold",
    color: theme.saleColor,
  },
  alignCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  list: {
    "list-style-type": "disc",
    padding: "0px",
    margin: "0px",
    "list-style-position": "inside",
    fontSize: "16px",
    fontWeight: 300,
    "&::marker": {
      color: "red",
    },
  },
  inlineLink: {
    textDecoration: "underline",
    color: theme.openButtonColor,
  },
  image: {
    maxWidth: "50%",
    marginTop: "20px",
  },
  imageUnder: {
    maxWidth: "50%",
    marginTop: "20px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "95%",
    },
  },
  imageUnder2: {
    maxWidth: "30%",
    marginTop: "20px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "80%",
    },
  },
  imageUnder3: {
    maxWidth: "30%",
    marginTop: "20px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "50%",
    },
  },
  imageUnder4: {
    maxWidth: "60%",
    // marginTop: "20px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "80%",
    },
  },
  imageUnder1: {
    maxWidth: "40%",
    marginTop: "20px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "70%",
    },
  },
  image1: {
    maxWidth: "70%",
    marginTop: "20px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "80%",
    },
  },
  bottomButton: {
    marginTop: "25px",
  },
  listItem: {
    display: "flex",
    border: "1px solid red",
    alignItems: "center",
  },
  listPoint: {
    backgroundColor: "black",
    width: "5px",
    height: "5px",
    marginRight: "10px",
    borderRadius: "2.5px",
  },
  listText: {},
  formContainer: {
    width: "80%",
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    justifySelf: "center",
    margin: "0px auto",
  },
  mainImage: {
    width: "400px",
    [theme.breakpoints.down("xs")]: {
      width: "80%",
    },
  },
  inputImageClass: {
    width: "170px",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
    },
  },
  inputImageClass1: {
    width: "250px",
    [theme.breakpoints.down("xs")]: {
      width: "80%",
    },
  },
  bottomImageClass: {
    width: "58.46%",
    [theme.breakpoints.down("xs")]: {
      width: "90%",
    },
  },
  bottomImageClass2: {
    width: "170px",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
    },
    marginBottom: "25px",
  },
  addTopMargin: {
    marginTop: "20px",
  },
  ResultsTitle: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "23px",
  },
  horizontalCenter: {
    textAlign: "center",
  },
}));

const BikeSpokeCalculator: FC = () => {
  const { t, lang } = useTranslation("spokeCalculator");
  const classes = useStyles();
  const [values, setValues] = useState({
    bikeType: BIKE_TYPE[0],
    insideDiameterOfTheRimAtNippleSeat: 556,
    isTopActive: true,
    innerDiameterOfTheRim: 556,
    rimFloorHeight: 0,
    erdDimensionDistanceLeft: 18,
    erdDimensionDistanceRight: 18,
    pitchCircleDiameterLeft: 38,
    pitchCircleDiameterRight: 38,
    spokeHoleDiameter: 32,
    wheelSpokeHoles: 32,
    desiredCrossoversLeft: "0",
    desiredCrossoversRight: "0",
    L1: "0",
    L2: "0",
  });

  const handleInputOnChange = (name, value) => {
    const onlyNumbersRegexDE = /^[0-9]*([,][0-9]*)?$/;
    const onlyNumbersRegexEN = /^[0-9]*([.][0-9]*)?$/;
    if (lang === "de" && name === "spokeHoleDiameter" && onlyNumbersRegexDE.test(value)) {
      setValues((el) => ({
        ...el,
        [name]: value,
      }));
    } else if (lang === "en" && name === "spokeHoleDiameter" && onlyNumbersRegexEN.test(value)) {
      setValues((el) => ({
        ...el,
        [name]: value,
      }));
    }

    if (name !== "spokeHoleDiameter") {
      if (name === "insideDiameterOfTheRimAtNippleSeat") {
        setValues((el) => ({
          ...el,
          [name]: value,
          isTopActive: true,
        }));
      } else if (name === "innerDiameterOfTheRim" || name === "rimFloorHeight") {
        setValues((el) => ({
          ...el,
          [name]: value,
          isTopActive: false,
        }));
      } else {
        setValues((el) => ({
          ...el,
          [name]: value,
        }));
      }
    }
  };

  const handleCalculate = () => {
    const spokeLengthValues = spokeLength(
      values?.insideDiameterOfTheRimAtNippleSeat,
      values?.innerDiameterOfTheRim,
      values?.rimFloorHeight,
      values?.isTopActive,
      values?.spokeHoleDiameter,
      values?.erdDimensionDistanceLeft,
      values?.pitchCircleDiameterLeft,
      values?.pitchCircleDiameterRight,
      Number(values?.desiredCrossoversLeft),
      values?.wheelSpokeHoles,
      Number(values?.desiredCrossoversRight),
      values?.erdDimensionDistanceRight
    );

    setValues((el) => ({
      ...el,
      L1: localNumber(spokeLengthValues.L1, 2, lang) || "0",
      L2: localNumber(spokeLengthValues.L2, 2, lang) || "0",
    }));
  };

  return (
    <CalculatorLayout
      header={
        <div data-test="page-rechner-fahrrad-speichenrechner">
          <PreCalculatorHeadline>{t("spokeCalculatorPreHeadline")}</PreCalculatorHeadline>
          <CalculatorHeadline>
            {t("spokeCalculatorHeadline")}
            <br /> {t("spokeCalculatorHeadline1")}
          </CalculatorHeadline>
        </div>
      }
    >
      <SeoHead
        title={t("spokeCalculatorOpenMetaTitle")}
        description={t("spokeCalculatorOpenMetaDescription")}
        ogImage="/images/calculators/The-Cycleverse-OpenGraph-Speichenrechner.png"
        ogDescription={t("spokeCalculatorOpenDescription")}
        ogTitle={t("spokeCalculatorOpenGraphTitle")}
      />
      <CalculatorImage
        src="/images/calculators/Speichenrechner-Header.svg"
        width={600}
        height={363}
        layout="intrinsic"
        alt={t("spokeCalculatorText74")}
      />

      <CalculatorButton text={t("spokeCalculatorButton1")} scroll idToScrollTo="Rechner" />

      <CalculatorBodyText>{t("spokeCalculatorText1")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText2")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText3")}</CalculatorBodyText>
      <div id="Rechner" />
      <CalculatorBodyText>{t("spokeCalculatorText4")}</CalculatorBodyText>

      <CalculatorInputSection
        inputTitle={t("spokeCalculatorText6")}
        inputNumber="1"
        isSelect
        onChange={(e) => handleInputOnChange("bikeType", e?.target?.value)}
        value={values?.bikeType}
      >
        {BIKE_TYPE.map((el) => (
          <MenuItem key={el} value={el}>
            {el}
          </MenuItem>
        ))}
      </CalculatorInputSection>
      {/* innerRimDiameter: field 2a */}
      <CalculatorInputSection
        inputTitle={t("spokeCalculatorText7")}
        inputCaption={t("spokeCalculatorText8")}
        inputImageUrl="/images/calculators/Speichenrechner-ERD-Maß.svg"
        imageAlt={t("spokeCalculatorText75")}
        inputNumber="2"
        isSlider
        selectZr={values?.insideDiameterOfTheRimAtNippleSeat}
        selectMaxZrLabel={"800 mm"}
        selectMaxZr={800}
        selectMinZrLabel="400 mm"
        selectMinZr={400}
        selectZrLabelUnit={`${values?.insideDiameterOfTheRimAtNippleSeat} mm`}
        onChange={(e) => handleInputOnChange("insideDiameterOfTheRimAtNippleSeat", e)}
        isNotActive={!values?.isTopActive}
        imageClass={classes.inputImageClass}
      />
      {/* rimBaseHeight: field 2b */}
      <CalculatorInputSection
        topInputCaption={t("spokeCalculatorText9")}
        inputTitle={t("spokeCalculatorText10")}
        inputImageUrl="/images/calculators/Speichenrechner-Felgeninnendurchmesser.svg"
        imageAlt={t("spokeCalculatorText76")}
        isNotSection={true}
        isSlider
        selectZr={values?.innerDiameterOfTheRim}
        selectMaxZrLabel={"800 mm"}
        selectMaxZr={800}
        selectMinZrLabel="400 mm"
        selectMinZr={400}
        selectZrLabelUnit={`${values?.innerDiameterOfTheRim} mm`}
        onChange={(e) => handleInputOnChange("innerDiameterOfTheRim", e)}
        isNotActive={values?.isTopActive}
        imageClass={classes.inputImageClass}
      />
      {/* rimBaseHeight: field 2c */}
      <CalculatorInputSection
        topInputCaption={t("spokeCalculatorText99")}
        inputTitle={t("spokeCalculatorText1000")}
        inputImageUrl="/images/calculators/Speichenrechner-Felgenbodenhöhe.svg"
        imageAlt={t("spokeCalculatorText77")}
        isNotSection={true}
        isSlider
        selectZr={values?.rimFloorHeight}
        selectMaxZrLabel={"30 mm"}
        selectMaxZr={30}
        selectMinZrLabel="1 mm"
        selectMinZr={1}
        selectZrLabelUnit={`${values?.rimFloorHeight} mm`}
        onChange={(e) => handleInputOnChange("rimFloorHeight", e)}
        isNotActive={values?.isTopActive}
        imageClass={classes.inputImageClass}
      />
      {/* erdDimensionDistanceLeft: field 3a */}
      <CalculatorInputSection
        inputTitle={t("spokeCalculatorText12")}
        inputImageUrl={field3Images[values?.bikeType]}
        imageAlt={t("spokeCalculatorText78")}
        inputNumber="3"
        bottomInputCaption={t("spokeCalculatorText13")}
        isSlider
        selectZr={values?.erdDimensionDistanceLeft}
        selectMaxZrLabel={"50,0 mm"}
        selectMaxZr={50}
        selectMinZrLabel="10,0 mm"
        selectMinZr={10}
        selectZrLabelUnit={`${values?.erdDimensionDistanceLeft} mm`}
        onChange={(e) => handleInputOnChange("erdDimensionDistanceLeft", e)}
        imageClass={classes.inputImageClass1}
      />
      {/* erdDimensionDistanceRight: field 3b */}
      <CalculatorInputSection
        bottomInputCaption={t("spokeCalculatorText14")}
        isNotSection={true}
        isSlider
        selectZr={values?.erdDimensionDistanceRight}
        selectMaxZrLabel={"10 mm"}
        selectMaxZr={50}
        selectMinZrLabel="50 mm"
        selectMinZr={10}
        selectZrLabelUnit={`${values?.erdDimensionDistanceRight} mm`}
        onChange={(e) => handleInputOnChange("erdDimensionDistanceRight", e)}
      />
      {/* pitchCircleDiameter: field 4a */}
      <CalculatorInputSection
        inputTitle={t("spokeCalculatorText15")}
        inputImageUrl={field4Images[values?.bikeType]}
        imageAlt={t("spokeCalculatorText79")}
        imageClass={classes.imageUnder4}
        inputNumber="4"
        bottomInputCaption={t("spokeCalculatorText131")}
        isSlider
        selectZr={values?.pitchCircleDiameterLeft}
        selectMaxZrLabel={"60 mm"}
        selectMaxZr={60}
        selectMinZrLabel="30 mm"
        selectMinZr={30}
        selectZrLabelUnit={`${values?.pitchCircleDiameterLeft} mm`}
        onChange={(e) => handleInputOnChange("pitchCircleDiameterLeft", e)}
      />
      {/* pitchCircleDiameter: field 4b */}
      <CalculatorInputSection
        bottomInputCaption={t("spokeCalculatorText141")}
        isNotSection={true}
        isSlider
        selectZr={values?.pitchCircleDiameterRight}
        selectMaxZrLabel={"60 mm"}
        selectMaxZr={60}
        selectMinZrLabel="30 mm"
        selectMinZr={30}
        selectZrLabelUnit={`${values?.pitchCircleDiameterRight} mm`}
        onChange={(e) => handleInputOnChange("pitchCircleDiameterRight", e)}
      />
      {/* spokeHoleDiameter: field 5a */}
      <CalculatorInputSection
        inputTitle={t("spokeCalculatorText16")}
        inputImageUrl="/images/calculators/Speichenlochdurchmesser.svg"
        imageAlt={t("spokeCalculatorText80")}
        bottomInputCaption=" "
        inputNumber="5"
        inputUnite="mm"
        onChange={(e) => handleInputOnChange("spokeHoleDiameter", e?.target?.value)}
        value={values?.spokeHoleDiameter}
        imageClass={classes.inputImageClass}
      />
      {/* wheelSpokeHoles: field 6a */}
      <CalculatorInputSection
        inputTitle={t("spokeCalculatorText17")}
        bottomInputCaption={<span className={`${classes.bottomTitle}`}>{t("spokeCalculatorText18")}</span>}
        inputNumber="6"
        isSelect
        onChange={(e) => handleInputOnChange("wheelSpokeHoles", e?.target?.value)}
        value={values?.wheelSpokeHoles}
      >
        {Array.from({ length: 25 }, (_, i) => i + 24)?.map((el) => (
          <MenuItem key={el} value={el}>
            {el}
          </MenuItem>
        ))}
      </CalculatorInputSection>
      {/* spokeHoleDiameter: field 6 b && c */}
      <CalculatorMultipleSelect
        bottomInputCaption={<span className={classes.bottomTitle}>{t("spokeCalculatorText19")}</span>}
        isNotSection
        secondBottomInputCaption="Bei radialer Einspeichung „0“ eingeben"
        inputProperties={[
          {
            // desiredCrossoversLeft: field 6 b
            value: values?.desiredCrossoversLeft,
            onChange: (e) => handleInputOnChange("desiredCrossoversLeft", e?.target?.value?.toString()),
            lowInputCaption: t("spokeCalculatorText20"),
            children: Array.from({ length: 6 }, (_, i) => i)?.map((el) => (
              <MenuItem key={el} value={el}>{`${el}`}</MenuItem>
            )),
          },
          {
            // desiredCrossoversRight: field 6 c
            value: values?.desiredCrossoversRight,
            onChange: (e) => handleInputOnChange("desiredCrossoversRight", e?.target?.value?.toString()),
            lowInputCaption: t("spokeCalculatorText21"),
            children: Array.from({ length: 6 }, (_, i) => i)?.map((el) => (
              <MenuItem key={el} value={el}>{`${el}`}</MenuItem>
            )),
          },
        ]}
      />

      <CalculatorButton text={t("spokeCalculatorText22")} onClick={handleCalculate} />

      <div className={`${classes.alignCenter}`}>
        <CalculatorResultsTitle text={t("spokeCalculatorText23")} />
        <CalculatorTopicH2Headline>{t("spokeCalculatorText24")}</CalculatorTopicH2Headline>
        <DisplayResult
          text1={t("spokeCalculatorText25")}
          result={`${values?.L1} mm`}
          unit={`(${t("spokeCalculatorText20")})`}
        />
        <DisplayResult
          text1={t("spokeCalculatorText26")}
          result={`${values?.L2} mm`}
          unit={`(${t("spokeCalculatorText21")}).`}
        />
        <div className={classes.addTopMargin} />
      </div>

      <CycleverseDivider />

      <CalculatorTopicH2Headline>{t("spokeCalculatorText27")}</CalculatorTopicH2Headline>
      <CalculatorBodyText>{t("spokeCalculatorText28")}</CalculatorBodyText>

      <CalculatorListItem>{t("spokeCalculatorText29")}</CalculatorListItem>
      <CalculatorListItem>{t("spokeCalculatorText30")}</CalculatorListItem>
      <CalculatorListItem>{t("spokeCalculatorText31")}</CalculatorListItem>
      <CalculatorListItem>{t("spokeCalculatorText32")}</CalculatorListItem>

      <CalculatorBodyText>
        {t("spokeCalculatorText33")}{" "}
        <LocaleLink href={`/werkzeuge`} as={`/werkzeuge`} target="new">
          {t("spokeCalculatorText34")}
        </LocaleLink>{" "}
        {t("spokeCalculatorText35")}
      </CalculatorBodyText>
      <CalculatorTopicH2Headline>{t("spokeCalculatorText36")}</CalculatorTopicH2Headline>
      <CalculatorBodyText>{t("spokeCalculatorText37")}</CalculatorBodyText>
      <div className={`${classes.alignCenter}`}>
        <img
          src="/images/calculators/Iso-Etrto.svg"
          alt={t("spokeCalculatorText81")}
          className={`${classes.imageUnder2}`}
        />
      </div>
      <CalculatorTopicH2Headline>{t("spokeCalculatorText38")}</CalculatorTopicH2Headline>
      <CalculatorBodyText>{t("spokeCalculatorText39")}</CalculatorBodyText>
      <div className={`${classes.alignCenter}`}>
        <img
          src="/images/calculators/Felgenbodenhoehe-ERD-Neu.svg"
          alt={t("spokeCalculatorText82")}
          className={`${classes.bottomImageClass}`}
        />
      </div>
      <CalculatorBodyText>{t("spokeCalculatorText40")}</CalculatorBodyText>
      <CalculatorTopicH2Headline>{t("spokeCalculatorText41")}</CalculatorTopicH2Headline>
      <CalculatorBodyText>{t("spokeCalculatorText42")}</CalculatorBodyText>

      <CalculatorListItem>{t("spokeCalculatorText43")}</CalculatorListItem>
      <CalculatorListItem>{t("spokeCalculatorText44")}</CalculatorListItem>
      <CalculatorListItem>{t("spokeCalculatorText45")}</CalculatorListItem>
      <CalculatorListItem>{t("spokeCalculatorText46")}</CalculatorListItem>

      <div className={`${classes.alignCenter}`}>
        <img
          src="/images/calculators/Alle-Nabenarten.svg"
          alt={t("spokeCalculatorText84")}
          className={`${classes.imageUnder}`}
        />
      </div>
      <CalculatorBodyText>{t("spokeCalculatorText47")}</CalculatorBodyText>
      <div className={`${classes.alignCenter}`}>
        <img
          src="/images/calculators/Naben-Messanleitung.svg"
          alt={t("spokeCalculatorText85")}
          className={`${classes.imageUnder1}`}
        />
      </div>

      <CalculatorBodyText>{t("spokeCalculatorText48")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText49")}</CalculatorBodyText>
      <CalculatorBodyText>
        <span className={`${classes.bottomTitle}`}>{t("spokeCalculatorText50")}</span>
        <br />
        {t("spokeCalculatorText51")}
      </CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText52")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText53")}</CalculatorBodyText>

      <CalculatorTopicH2Headline>{t("spokeCalculatorText54")}</CalculatorTopicH2Headline>
      <div className={classes.alignCenter}>
        <img
          src="/images/calculators/Alle-Messpunkte-Speichenlochkreisdurchmesser.svg"
          alt={t("spokeCalculatorText86")}
          className={`${classes.imageUnder3}`}
        />
      </div>
      <CalculatorBodyText>{t("spokeCalculatorText55")}</CalculatorBodyText>
      <CalculatorBodyText>
        <span className={`${classes.bottomTitle}`}>{t("spokeCalculatorText56")}</span>
        <br />
        {t("spokeCalculatorText57")}
      </CalculatorBodyText>

      <CalculatorBodyText>
        {t("spokeCalculatorText58")}
        <br />
        {t("spokeCalculatorText59")}
      </CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText60")}</CalculatorBodyText>

      <CalculatorTopicH2Headline>{t("spokeCalculatorText61")}</CalculatorTopicH2Headline>
      <CalculatorBodyText>{t("spokeCalculatorText62")}</CalculatorBodyText>
      <div className={classes.alignCenter}>
        <img
          src="/images/calculators/Vergleich-radiale-und-tangentiale-Einspeichung.png"
          alt={t("spokeCalculatorText87")}
          className={`${classes.image1}`}
        />
      </div>
      <CalculatorBodyText>{t("spokeCalculatorText63")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText64")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText65")}</CalculatorBodyText>

      <CalculatorListItem>{t("spokeCalculatorText66")}</CalculatorListItem>
      <CalculatorListItem>{t("spokeCalculatorText67")}</CalculatorListItem>
      <CalculatorListItem>{t("spokeCalculatorText68")}</CalculatorListItem>

      <CalculatorBodyText>{t("spokeCalculatorText69")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText70")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText71")}</CalculatorBodyText>
      <CalculatorBodyText>{t("spokeCalculatorText72")}</CalculatorBodyText>

      <CalculatorButton text={t("spokeCalculatorButton2")} scroll idToScrollTo="Rechner" />
      <CalculatorTopicH2Headline>{t("spokeCalculatorText73")}</CalculatorTopicH2Headline>
      <CalculatorButtonLinkCentered href="/werkzeuge" text={t("spokeCalculatorButton3")} />
    </CalculatorLayout>
  );
};

export default BikeSpokeCalculator;
